var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconControlPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 8.26522 14.8946 8.51957 14.7071 8.70711C14.5196 8.89464 14.2652 9 14 9H2C1.73478 9 1.48043 8.89464 1.29289 8.70711C1.10536 8.51957 1 8.26522 1 8C1 7.73478 1.10536 7.48043 1.29289 7.29289C1.48043 7.10536 1.73478 7 2 7H14C14.2652 7 14.5196 7.10536 14.7071 7.29289C14.8946 7.48043 15 7.73478 15 8Z",
    fill: "#A2A7B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00006 2V14C9.00006 14.2652 8.8947 14.5196 8.70717 14.7071C8.51963 14.8946 8.26528 15 8.00006 15C7.73484 15 7.48049 14.8946 7.29295 14.7071C7.10542 14.5196 7.00006 14.2652 7.00006 14V2C7.00006 1.73478 7.10542 1.48043 7.29295 1.29289C7.48049 1.10536 7.73484 1 8.00006 1C8.26528 1 8.51963 1.10536 8.70717 1.29289C8.8947 1.48043 9.00006 1.73478 9.00006 2Z",
    fill: "#A2A7B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPlus);
export default __webpack_public_path__ + "static/media/icon_control_plus.f7915b6f76f5f5fabf81c813071be655.svg";
export { ForwardRef as ReactComponent };